import React, { useEffect, useState } from "react";
import { Link, useMatch, useLocation } from "react-router-dom";
import { FaUser, FaSignOutAlt, FaRobot, FaFlask } from "react-icons/fa";
import { FaMoneyBillTrendUp, FaArrowRightToBracket, FaGauge } from "react-icons/fa6";
import { Navbar, Nav, Container } from "react-bootstrap";
import ThemeToggle from "./components/ThemeToggle";

const AppNavLink = ({ to, children, onClose }) => {
  const isActive = useMatch({ path: to, end: false });
  return (
    <Nav.Link
      as={Link}
      to={to}
      className={`rv-nav-link${isActive ? " rv-nav-active" : ""}`}
      onClick={onClose}
    >
      {children}
    </Nav.Link>
  );
};

const SiteNavbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const close = () => setExpanded(false);

  useEffect(() => {
    if (!isHomePage) return;
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHomePage]);

  // Close on route change
  useEffect(() => { close(); }, [location.pathname]);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={setExpanded}
      className={[
        "rv-navbar",
        isHomePage ? "rv-navbar-home" : "rv-navbar-app",
        isHomePage && scrolled ? "rv-navbar-scrolled" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <Container fluid className="px-3 px-lg-5">
        {/* Brand */}
        <Navbar.Brand as={Link} to={sessionStorage.getItem("jwt") ? "/app" : "/"} className="rv-brand">
          <span className="rv-brand-icon">
            <FaRobot />
          </span>
          <span className="rv-brand-text">RoboVest</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" className="rv-toggler" />

        <Navbar.Collapse id="main-navbar">
          {!isHomePage && (
            <Nav className="me-auto gap-1">
              <AppNavLink to="/app" onClose={close}>
                <FaGauge className="me-1" /> Dashboard
              </AppNavLink>
              <AppNavLink to="/strategies/TradingStrategies" onClose={close}>
                <FaMoneyBillTrendUp className="me-1" /> Strategies
              </AppNavLink>
              <AppNavLink to="/backtest" onClose={close}>
                <FaFlask className="me-1" /> Backtester
              </AppNavLink>
              <AppNavLink to="/user/profile" onClose={close}>
                <FaUser className="me-1" /> Profile
              </AppNavLink>
            </Nav>
          )}

          {isHomePage && <Nav className="me-auto" />}

          <div className="d-flex align-items-center gap-2">
            {!isHomePage && <ThemeToggle />}

            {isHomePage ? (
              <>
                <Link to="/login" className="rv-nav-login" onClick={close}>
                  <FaArrowRightToBracket className="me-1" />
                  Login
                </Link>
                <Link to="/signup" className="rv-nav-signup" onClick={close}>
                  Sign Up
                </Link>
              </>
            ) : (
              <Nav.Link
                as={Link}
                to="/logout"
                className="rv-nav-link d-flex align-items-center gap-1"
                style={{ opacity: 0.6, fontSize: "0.875rem" }}
                onClick={close}
              >
                <FaSignOutAlt /> Logout
              </Nav.Link>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default SiteNavbar;
